// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"29654378","239":"a56a45d9","732":"cfe3ab17"}[chunkId] + ".chunk.js";
};